import type { StatusIndicator, TimeRange } from "./types";
import { i18n } from "@tellescope/i18n";

export const TIME_RANGES: Array<{ key: TimeRange; label: string }> = [
  { key: "week", label: i18n.t("Week", { ns: "vitals" }) },
  { key: "month", label: i18n.t("Month", { ns: "vitals" }) },
  { key: "year", label: i18n.t("Year", { ns: "vitals" }) },
  { key: "all", label: i18n.t("All", { ns: "vitals" }) },
] as const;

export const STATUS_FILTERS: Array<{
  key: StatusIndicator;
  label: string;
  dotClass: string;
  activeClass: string;
}> = [
  {
    key: "L",
    label: i18n.t("Low", { ns: "vitals" }),
    dotClass: "bg-blue-500",
    activeClass:
      "bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-950/50 dark:border-blue-900/50 dark:text-blue-300",
  },
  {
    key: "N",
    label: i18n.t("In Range", { ns: "vitals" }),
    dotClass: "bg-emerald-500",
    activeClass:
      "bg-emerald-50 border-emerald-200 text-emerald-700 dark:bg-emerald-950/50 dark:border-emerald-900/50 dark:text-emerald-300",
  },
  {
    key: "H",
    label: i18n.t("High", { ns: "vitals" }),
    dotClass: "bg-orange-500",
    activeClass:
      "bg-orange-50 border-orange-200 text-orange-700 dark:bg-orange-950/50 dark:border-orange-900/50 dark:text-orange-300",
  },
] as const;

export const DOT_COLORS: Record<string, string> = {
  H: "#f97316", // orange-500
  L: "#3b82f6", // blue-500
  N: "#10b981", // emerald-500
  default: "#6b7280", // gray-500
} as const;

export const CHART_COLORS = {
  bar: {
    H: "#fed7aa", // orange-200
    L: "#bfdbfe", // blue-200
    N: "#a7f3d0", // emerald-200
    default: "#e5e7eb", // gray-200
  },
  line: {
    stroke: "#111827", // gray-900
    activeDot: "#111827", // gray-900
  },
} as const;

export const STATUS_BADGE_VARIANTS = {
  high: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/50 dark:text-orange-300 dark:border-orange-900/50",
  low: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/50 dark:text-blue-300 dark:border-blue-900/50",
  normal:
    "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/50 dark:text-emerald-300 dark:border-emerald-900/50",
  recorded: "bg-gray-100 text-gray-500 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700",
} as const;
